import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
const suppressResizeObserverErrors = () => {
  // Suppress console errors
  const originalError = console.error;
  console.error = (...args) => {
    if (
      args[0]?.includes?.('ResizeObserver') ||
      args[0]?.message?.includes?.('ResizeObserver')
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress window errors
  window.addEventListener('error', (event) => {
    if (
      event.message?.includes('ResizeObserver') ||
      event.error?.message?.includes('ResizeObserver')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  });

  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason?.message?.includes('ResizeObserver') ||
      event.reason?.includes?.('ResizeObserver')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  });

  // Override ResizeObserver to catch errors
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            if (!e.message?.includes('ResizeObserver')) {
              throw e;
            }
          }
        });
      });
    }
  };
};

suppressResizeObserverErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
